import React from "react";
import {
    Button,
    Row,
    Container,
    Col,
} from "react-bootstrap";

function NoRoute() {

    return (



        <Container className="p-5" style={{ minHeight: '100%' }}>

            <Row className="m-auto">
                <h2 className="text-light text-center">Your event has expired.</h2>
                <h5 className="text-light text-center">Please contact your PinStack Rep.</h5>
            </Row>
        </Container>

    )
}
export default NoRoute;